module.exports = __webpack_public_path__ + "img/right-front-arm.d99629c4.svg";